import React, { Component } from 'react';
import PropTypes from 'prop-types';

class FluidAd extends Component {
  googleInit = null;

  componentDidMount() {
    const { timeout } = this.props;
    this.googleInit = setTimeout(() => {
      if (typeof window !== 'undefined')
        (window.adsbygoogle = window.adsbygoogle || []).push({});
    }, timeout);
  }

  componentWillUnmount() {
    if (this.googleInit) clearTimeout(this.googleInit);
  }

  render() {
    const { classNames } = this.props;
    return (
      <div className={classNames}>
        <ins 
          className="adsbygoogle" 
          style={{display: 'block'}} 
          data-ad-format="fluid" 
          data-ad-layout-key="-ef+6k-30-ac+ty" 
          data-ad-client="ca-pub-4817534541991617" 
          data-ad-slot="8110749764"
        ></ins>
      </div>
    );
  }
}

FluidAd.propTypes = {
  classNames: PropTypes.string,
  timeout: PropTypes.number,
};

FluidAd.defaultProps = {
  classNames: '',
  timeout: 200,
};

export default FluidAd;